import React from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import axios from "axios";

import MasterIndustryEditForm from "./MasterIndustryEditForm";
import formatZdate from "../../../utils/formatZdate";

const getIndustryOneAPI = `${process.env.REACT_APP_API_URL}api/industry`;

const MasterIndustryEdit = ({ buttonConfig, selectedItemId, isButtonClicked }) => {
  const schema = z.object({
    industry: z.string().nonempty(),
    industry_code: z.string().nonempty(),
    basic_industry: z.string().nonempty(),
    sector: z.string().nonempty(),

    sector_code: z.string().nonempty(),
    mes_code: z.string().nonempty(),
    macro_economic_sector: z.string().nonempty(),
    bi_code: z.string().nonempty(),

    vidal_code: z.string().nonempty(),
    eff_start_date: z.string().nonempty(),
    eff_end_date: z.string().nullable(),
  });

  const headers = {
    Authorization: `Bearer ${sessionStorage.getItem("subscriberToken")
    ? sessionStorage.getItem("subscriberToken")
    : sessionStorage.getItem("token")}`,
    "Content-Type": "application/json",
  };

  const form = useForm({
    defaultValues: async () => {
      const getSegment = `${getIndustryOneAPI}/${selectedItemId}`;
      const res = await axios.get(getSegment, { headers });
      const segment = res.data.data;
      // console.log(segment);
      return {
        industry: segment.industry,
        industry_code: segment.industry_code,
        basic_industry: segment.basic_industry,
        sector: segment.sector,

        sector_code: segment.sector_code,
        mes_code: segment.mes_code,
        macro_economic_sector: segment.macro_economic_sector,
        bi_code: segment.bi_code,

        vidal_code: segment.vidal_code,
        eff_start_date: segment.eff_start_date,
        eff_end_date: segment.eff_end_date,
        status: "true",
      };
    },
    resolver: zodResolver(schema),
  });

  return (
    <MasterIndustryEditForm
      form={form}
      segmentName={buttonConfig.name}
      editHandler={buttonConfig.editHandler}
      closeHandler={buttonConfig.closeEditModal}
      selectedItemId={selectedItemId}
      isButtonClicked={isButtonClicked}
    />
  );
};

export default MasterIndustryEdit;
